import React from "react";

function Contact() {
  document.title = "This page is not finished yet";
  return (
    <div>
      <h1>Contact</h1>
    </div>
  );
}

export default Contact;
